import Directories from 'components/Directories'
import { PROVIDERS, RESULTS_TYPES } from 'utils/DirectoryParser'

const IndividualsJobsDirectories = (props) => (
  <Directories
    props={props}
    directoryLabel='Jobs For Individuals'
    directoryProvider={PROVIDERS.INDIVIDUALS}
    directoryBasePath={PROVIDERS.INDIVIDUALS.jobsBasePath}
    directoryResultsType={RESULTS_TYPES.JOBS}
  />
)

export default IndividualsJobsDirectories
